import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styles from './AutoRenewal.module.css'
import { FormattedMessage } from 'react-intl'

// 自动更新（签约）流程已去掉支付能力：本页只做绑定成功确认，
// 不再自动拉起支付，也不提供任何支付入口
const AutoRenewSuccess = () => {
  const { state } = useLocation()
  const { core: coreState } = state || {}

  useEffect(() => {
    document.body.style.setProperty('background-color', '#ffffff', 'important')
    return () => {
      document.body.style.setProperty('background-color', '#f5f5f9', 'important')
    }
  }, [])

  return (
    <div className={styles['success-cntent']}>
      <div className={styles.header}>
        <img src={require('../../assets/images/logo/padi-logo-dark.png')} alt="" className={styles['padi-logo']} />
      </div>
      <img src={require('../../assets/images/common/check-success.png')} alt="" className={styles['success-logo']} />
      <div className={styles['large-text']}>
        <FormattedMessage id="auto-renew-member-bind-success" />
      </div>
      {coreState ? <div className={styles.core}>{coreState}</div> : null}
    </div>
  )
}

export default AutoRenewSuccess
